import isEmpty from "lodash.isempty";
import { BOWLS_TYPES } from "../../components/ReusableBowls/BowlsTypes";
import { PAGES } from "./CheckoutProvider";

export const SESSION_NAME = "Checkout";

const EMPTY_ADDRESS_OBJECT = {
    first_name: "",
    last_name: "",
    company: "",
    address: "",
    postcode: "",
    city: "",
    country: "DE",
    legal_form: undefined,
};

const initialState = {
    page: PAGES.CART,
    toasts: [],
    user: {},
    paymentOption: null,
    timeSlot: {},
    orderId: null,
    orderAddress: {
        sameAsBilling: true,
        billing_address: EMPTY_ADDRESS_OBJECT,
        shipping_address: EMPTY_ADDRESS_OBJECT,
        contact: {
            phone: "",
            email: "",
        },
    },
    isCompanyOrder: null,
    reusableBowls: BOWLS_TYPES.CLASSIC, // DEFAULTS TO CLASSIC
};

const init = (initialState) => {
    const checkoutSession = sessionStorage.getItem(SESSION_NAME);
    const sessionExists = !!checkoutSession && "undefined" !== checkoutSession;

    if (sessionExists) {
        return JSON.parse(checkoutSession);
    }

    return initialState;
};

const get = () => {
    return JSON.parse(sessionStorage.getItem(SESSION_NAME));
};

const isSet = () => {
    try {
        const value = get();
        return !isEmpty(value) && !!value;
    } catch (error) {
        return false;
    }
};

const isReusableToggled = () => {
    const sessionData = get();
    return sessionData.reusableBowls === BOWLS_TYPES.REUSABLE;
};

const update = (state) =>
    sessionStorage.setItem(SESSION_NAME, JSON.stringify(state));

export default { init, initialState, update, get, isSet, isReusableToggled };
